<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="filterOptions"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'SelectActivation',

    mixins: [DataUpdater],

    data() {
        return {
            option: null,
            filterOptions: [
                { text: 'Clients actifs et anciens', value: 'all' },
                { text: 'Clients actifs', value: 'active' },
                { text: 'Anciens clients', value: 'old' },
            ],
        }
    },

    computed: {
        ...mapState({
            activationFilter: (state) => state.browsing.clientsActivationFilter,
        }),

        selectClass() {
            return this.option === 'active'
                ? 'bg-white'
                : 'bg-info text-primary font-weight-bold'
        },
    },

    created() {
        this.option = this.activationFilter
    },

    methods: {
        async setFilter() {
            this.$store.commit(
                'browsing/SET_CLIENT_ACTIVATION_FILTER',
                this.option
            )
            this.$emit('activation-filter-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>

<style scoped></style>
